import {lazy} from 'react';

export const NewsArchiveLazy = lazy(() => import(/* webpackChunkName: "newsArchive" */ '.'));
